import { Accordion } from 'flowbite-react';
const AgricultureFAQ: React.FC = () => {
    return (
        <>
            <Accordion>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        How can agriculture software benefit my farm or agribusiness?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary">
                            Agriculture software streamlines operations, improves data visibility, and helps automate tasks like
                            irrigation, inventory, and livestock tracking. It leads to better decision-making, reduced waste, and
                            increased productivity—especially when paired with smart farming solutions.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        What technologies are commonly used in agricultural software?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary">
                            Technologies often include IoT sensors, GPS mapping, drone integrations, AI/ML algorithms, and
                            cloud-based dashboards. These tools support precision agriculture, farm monitoring, and efficient data
                            management across your operations.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        What is the cost of building an agriculture software solution?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary">
                            The cost depends on the features, scale, and complexity of your project. A basic farm management app
                            may cost less, while custom agriculture ERP software or drone-integrated systems may require a higher
                            investment. We offer tailored pricing models.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        How is AI used in Agriculture?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary">
                            AI is used for disease detection, yield prediction, crop monitoring, and automating decisions like
                            irrigation or spraying. AI solutions for agriculture help reduce manual intervention while increasing
                            accuracy and efficiency on the field.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        Can your agriculture software integrate with IoT or drones?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary">
                            Yes, our agriculture software development services include seamless integration with IoT devices and
                            drones. This enables real-time data capture, aerial scouting, and automation of field tasks—vital for
                            modern precision farming.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        How long does it take to build an agriculture software?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary">
                            Timelines vary based on scope. Simple agritech apps can take 4-8 weeks, while complex systems like
                            farm ERPs or drone platforms may take 3-6 months. We use agile development to deliver faster,
                            iterative results.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        What features are commonly included in agritech app development?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary">
                            Agritech apps often include GPS mapping, weather updates, task tracking, inventory management, AI
                            recommendations, and integration with sensors or drones. Custom features are added based on your
                            specific use case.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
            </Accordion>
        </>
    );
};

export default AgricultureFAQ;
